import React, { Fragment, useEffect, useState } from 'react';

const DropDown = (props) => {

    const [active, setActive] = useState(false)
    const [show, setShow] = useState(false)

    useEffect(() => {
        togglePopup(props.active)
    }, [props.active])

    const togglePopup = (status) => {
        if (status) {
            setActive(true)
            setTimeout(() => {
                setShow(true)
            }, 350);
        } else {
            setShow(false)
            setTimeout(() => {
                setActive(false)
            }, 350);
        }
    }

    return (
        <Fragment>
            <div className={`dropdown-smsng ${active ? 'active' : ''} ${show ? 'show' : ''}`}>
                <div
                    className="overlay"
                    onClick={() => props.closePopup()}></div>
                <div className={`inner-dropdown ${props.class == undefined ? '' : props.class}`}>
                    {props.children}
                </div>
            </div>
        </Fragment>
    );
}

export default DropDown;